{
  "title": "Rapports",
  "subtitle": "Choisissez une question à gauche. Chaque rapport peut être filtré et exporté vers Excel.",
  "subtitleMobile": "Choisissez une question. Chaque rapport peut être filtré et exporté vers Excel.",
  "back": "Rapports",
  "export": "Exporter vers Excel",
  "groups": {
    "sales": "Ventes",
    "suppliers": "Fournisseurs",
    "now": "Le stock maintenant",
    "moved": "Ce qui a bougé",
    "trends": "Tendances"
  },
  "items": {
    "stock-status": {
      "title": "État du stock",
      "question": "Qu'est-ce que j'ai, et qu'est-ce qui est bas ou en rupture ?",
      "description": "Chaque produit actif avec sa quantité, ses limites et son état."
    },
    "valuation": {
      "title": "Valorisation",
      "question": "Combien vaut mon stock ?",
      "description": "Valeur du stock au coût moyen pondéré, par emplacement, par catégorie et par produit."
    },
    "negative": {
      "title": "Stock négatif",
      "question": "Où le système est-il sous zéro ?",
      "description": "Chaque produit et endroit sous zéro, avec le document qui l'a confirmé."
    },
    "stock-at": {
      "title": "Stock à une date passée",
      "question": "Qu'est-ce que j'avais tel jour ?",
      "description": "Le stock en fin de journée choisie, reconstitué à partir des mouvements."
    },
    "movements": {
      "title": "Mouvements par période",
      "question": "Qu'est-ce qui est entré et sorti, et qui l'a fait ?",
      "description": "Entrées et sorties par produit, par type d'opération et par personne."
    },
    "adjustments": {
      "title": "Ajustements et pertes",
      "question": "Qu'est-ce qui a été abîmé, perdu ou retrouvé ?",
      "description": "Corrections par motif et par produit, avec ce qu'elles ont ajouté et retiré."
    },
    "transfers": {
      "title": "Transferts",
      "question": "Qu'est-ce qui a bougé entre emplacements, et y a-t-il du retard ?",
      "description": "Transferts de la période, leur état, leur retard et ce qui a été perdu en route."
    },
    "counts": {
      "title": "Écarts d'inventaire",
      "question": "Les inventaires étaient-ils loin du système ?",
      "description": "Inventaires validés et leurs écarts. Ouvrez les lignes d'un inventaire pour voir ce qui différait."
    },
    "movers": {
      "title": "Meilleures sorties et stock dormant",
      "question": "Qu'est-ce qui sort le plus, et qu'est-ce qui ne bouge jamais ?",
      "description_one": "Ce qui sort le plus, et ce qui n'a pas bougé depuis {{count}} jour ou plus.",
      "description_other": "Ce qui sort le plus, et ce qui n'a pas bougé depuis {{count}} jours ou plus."
    },
    "user-activity": {
      "title": "Activité des utilisateurs",
      "question": "Qui a fait combien, et quand ?",
      "description": "Les actions de chaque personne sur la période."
    },
    "sales": {
      "title": "Ventes",
      "question": "Combien avons-nous vendu, où et par qui ?",
      "description": "Les ventes par jour, emplacement, canal, caisse et caissier, TTC : une vente compte le jour où ses articles ont été remis, un retour le jour où il est revenu. Par mode de prix : les ventes au détail et en gros à part, avec leurs remises."
    },
    "sales-products": {
      "title": "Ventes par produit",
      "question": "Qu'est-ce qui s'est vendu, et combien est revenu ?",
      "description": "Les quantités vendues et retournées, leur prix moyen, leurs remises et ce qu'elles ont rapporté, TTC, par produit ou par produit à variantes ; sous un produit vendu en gros, sa part en gros."
    },
    "payments": {
      "title": "Paiements",
      "question": "Comment l'argent a-t-il été encaissé, et que doivent encore les livreurs ?",
      "description": "Les paiements et remboursements par mode et par caisse, comptés comme les rapports Z ; les versements des livreurs et les contre-remboursements non versés."
    },
    "tax": {
      "title": "TVA",
      "question": "Combien de TVA pour la déclaration ?",
      "description": "La TVA par mois et par taux, comme les factures et tickets la répartissent, retours et remboursements déduits ; les documents émis et le droit de timbre."
    },
    "z-reports": {
      "title": "Rapports Z",
      "question": "Avec quoi chaque caisse a-t-elle clôturé ?",
      "description": "Les rapports Z de la période : ce que chaque service a encaissé, les espèces attendues et comptées, l’écart."
    },
    "margins": {
      "title": "Marges",
      "question": "Qu'avons-nous gagné sur les marchandises ?",
      "description": "Les ventes HT, leur coût à la sortie du stock et la marge, par produit et par catégorie. La livraison est laissée de côté."
    },
    "purchases": {
      "title": "Achats",
      "question": "Qu'avons-nous reçu des fournisseurs, et que reste-t-il à payer ?",
      "description": "Les réceptions de la période avec leur montant à payer, ce que les paiements effectués ont payé et ce qui reste ; par fournisseur."
    },
    "supplier-payments": {
      "title": "Paiements fournisseurs",
      "question": "Qu'avons-nous payé aux fournisseurs, et comment ?",
      "description": "Les paiements de la période, au jour où ils ont été payés, et ceux prévus à leur échéance ; par mode et par fournisseur. Les paiements annulés ne comptent pas."
    },
    "supplier-balances": {
      "title": "Soldes fournisseurs",
      "question": "Que devons-nous à chaque fournisseur aujourd'hui ?",
      "description": "Pour chaque fournisseur : le montant à payer de ses réceptions, ce qui est payé, prévu et avancé, et le solde ; puis chaque réception pas entièrement payée, la plus ancienne d'abord."
    },
    "day": {
      "title": "Rapport journalier",
      "question": "Comment s’est passée la journée ?",
      "description": "Une journée de l’entreprise ou d’un emplacement : les ventes heure par heure, l’argent encaissé, les caisses, ce qu’il faut vérifier, les meilleures ventes et les meilleurs clients, les commandes, le stock déplacé et les fournisseurs payés. Ses chiffres sont ceux des autres rapports pour ce jour."
    },
    "promotions": {
      "title": "Promotions",
      "question": "Qu'a vendu et donné chaque promotion ?",
      "description": "Pour chaque promotion, les tickets, les pièces, ce qu’elle a retiré, les ventes et la marge, nets des retours."
    }
  },
  "filters": {
    "period": "Période",
    "location": "Emplacement",
    "category": "Catégorie",
    "state": "État",
    "date": "Date",
    "type": "Type",
    "reason": "Motif",
    "status": "Statut",
    "all": "Tous",
    "from": "Du",
    "to": "Au",
    "allCategories": "Toutes",
    "variants": "Variantes",
    "variantsEach": "Une ligne chacune",
    "variantsProduct": "Groupées par produit",
    "channel": "Canal",
    "register": "Caisse",
    "supplier": "Fournisseur",
    "receiptStatus": "Paiement",
    "method": "Mode",
    "day": "Jour",
    "previousDay": "Jour précédent",
    "nextDay": "Jour suivant",
    "today": "Aujourd’hui",
    "allDates": "Toutes les dates"
  },
  "periods": {
    "today": "Aujourd’hui",
    "yesterday": "Hier",
    "7d": "7 derniers jours",
    "30d": "30 derniers jours",
    "90d": "90 derniers jours",
    "month": "Ce mois-ci",
    "lastMonth": "Le mois dernier",
    "year": "Cette année",
    "day": "Un jour…",
    "custom": "Dates au choix"
  },
  "range": "{{from}} – {{to}}",
  "sections": {
    "products": "Produits",
    "bySite": "Par emplacement",
    "byCategory": "Par catégorie",
    "pairs": "Sous zéro",
    "types": "Par type d'opération",
    "people": "Par personne",
    "reasons": "Par motif",
    "transfers": "Transferts",
    "counts": "Inventaires",
    "lines": "Lignes avec écart",
    "top": "Top {{count}} en valeur sortie",
    "topQuantity": "Top {{count}} des sorties",
    "dead": "Stock dormant",
    "byDay": "Par jour",
    "byChannel": "Par canal",
    "byRegister": "En caisse, par caisse",
    "byCashier": "En caisse, par caissier",
    "byMethod": "Par mode de paiement",
    "settlements": "Versements des livreurs",
    "byCarrier": "Par livreur",
    "codPending": "Contre-remboursements non versés",
    "byRate": "Par mois et par taux",
    "documents": "Documents émis",
    "zReports": "Rapports Z",
    "receipts": "Réceptions",
    "bySupplier": "Par fournisseur",
    "payments": "Paiements",
    "balances": "Soldes",
    "openReceipts": "Réceptions pas entièrement payées",
    "byPricingMode": "Par mode de prix",
    "byHour": "Ventes par heure",
    "shifts": "Services et caisses",
    "exceptions": "À vérifier",
    "topProducts": "Meilleures ventes",
    "topCustomers": "Meilleurs clients",
    "orderFlow": "Commandes en ligne et du back-office",
    "stockTypes": "Stock déplacé, par opération",
    "operations": "Opérations de stock validées",
    "adjustmentReasons": "Ajustements par motif",
    "supplierPayments": "Paiements fournisseurs",
    "supplierDue": "Paiements fournisseurs dus demain",
    "promotions": "Promotions"
  },
  "columns": {
    "sku": "Référence",
    "product": "Produit",
    "category": "Catégorie",
    "quantity": "Quantité",
    "min": "Min",
    "max": "Max",
    "state": "État",
    "value": "Valeur (TND)",
    "lastMovement": "Dernier mouvement",
    "site": "Emplacement",
    "share": "Part",
    "products": "Produits",
    "averageCost": "Coût moyen (TND)",
    "location": "Emplacement",
    "document": "Document",
    "confirmedBy": "Confirmé par",
    "in": "Entrées",
    "out": "Sorties",
    "net": "Net",
    "inValue": "Entrées (TND)",
    "outValue": "Sorties (TND)",
    "lines": "Lignes",
    "operationType": "Opération",
    "operations": "Opérations",
    "person": "Personne",
    "reason": "Motif",
    "adjustments": "Ajustements",
    "addedValue": "Ajouté (TND)",
    "removedValue": "Retiré (TND)",
    "added": "Ajouté",
    "removed": "Retiré",
    "number": "Numéro",
    "from": "De",
    "to": "Vers",
    "status": "Statut",
    "sent": "Envoyé",
    "received": "Reçu",
    "days": "Jours",
    "lostLines": "Lignes perdues",
    "lossValue": "Perdu (TND)",
    "validated": "Validé",
    "different": "Lignes avec écart",
    "percent": "Écart",
    "expected": "Attendu",
    "counted": "Compté",
    "difference": "Écart",
    "actions": "Actions",
    "receipts": "Réceptions",
    "issues": "Sorties",
    "transfers": "Transferts",
    "counts": "Inventaires",
    "signIns": "Connexions",
    "last": "Dernière action",
    "variants": "Variantes",
    "day": "Jour",
    "orders": "Commandes",
    "sales": "Ventes",
    "returns": "Retours",
    "allowances": "Remboursements sans retour",
    "tax": "TVA",
    "channel": "Canal",
    "channelType": "Type",
    "register": "Caisse",
    "cashier": "Caissier",
    "sold": "Vendu",
    "returned": "Retourné",
    "salesExclTax": "Ventes HT",
    "cost": "Coût",
    "margin": "Marge",
    "marginPercent": "Marge %",
    "method": "Mode",
    "count": "Nombre",
    "refunded": "Remboursé",
    "date": "Date",
    "carrier": "Livreur",
    "handedIn": "Versé",
    "outOrders": "Commandes non versées",
    "stillOut": "Non versé",
    "reference": "Référence",
    "total": "Total",
    "customer": "Client",
    "shipped": "Expédiée",
    "due": "Dû",
    "month": "Mois",
    "rate": "Taux",
    "gross": "TTC",
    "documentType": "Document",
    "stampDuty": "Droit de timbre",
    "closed": "Clôturée",
    "variance": "Écart",
    "approvedBy": "Approuvé par",
    "supplier": "Fournisseur",
    "theirReference": "Leur référence",
    "goodsValue": "Valeur des marchandises",
    "amountDue": "Montant à payer",
    "paid": "Payé",
    "open": "Reste à payer",
    "receiptStatus": "Paiement",
    "payments": "Paiements",
    "paymentStatus": "Statut",
    "amount": "Montant",
    "scheduled": "Prévu",
    "advance": "Avance",
    "balance": "Solde",
    "openReceipts": "Réceptions ouvertes",
    "oldestOpen": "Plus ancienne ouverte",
    "age": "Ancienneté",
    "pricingMode": "Prix",
    "units": "Quantité vendue",
    "beforeDiscounts": "Avant remises",
    "discounts": "Remises",
    "averagePrice": "Prix moyen",
    "hour": "Heure",
    "opened": "Ouvert",
    "shiftStatus": "Statut",
    "float": "Fond de caisse",
    "time": "Heure",
    "dayEvent": "Quoi",
    "where": "Où",
    "detail": "Détail",
    "orderEvent": "Étape",
    "online": "En ligne",
    "backOffice": "Back-office",
    "partner": "Tiers",
    "discountPercent": "Remise %",
    "promotion": "Promotion",
    "tickets": "Tickets"
  },
  "codes": {
    "stockState": {
      "in_stock": "En stock",
      "low": "Bas",
      "out": "Rupture",
      "negative": "Négatif",
      "overstock": "Surstock"
    },
    "transferStatus": {
      "draft": "Brouillon",
      "sent": "Envoyé",
      "partially_received": "Reçu en partie",
      "received": "Reçu",
      "cancelled": "Annulé"
    },
    "operationType": {
      "stockIn": "Entrée",
      "stockOut": "Sortie",
      "adjustment": "Ajustement",
      "openingStock": "Stock d'ouverture",
      "transfer": "Transfert",
      "order": "Ventes et commandes"
    },
    "paymentMethod": {
      "cash": "Espèces",
      "card": "Carte",
      "cheque": "Chèque",
      "transfer": "Virement",
      "cashOnDelivery": "Contre-remboursement",
      "payAtPickup": "Paiement au retrait",
      "online": "En ligne"
    },
    "channelType": {
      "pos": "Comptoir",
      "online": "Boutique en ligne",
      "backOffice": "Back-office"
    },
    "documentType": {
      "receipt": "Tickets de caisse",
      "invoice": "Factures",
      "creditNote": "Avoirs"
    },
    "receiptStatus": {
      "unpaid": "Non payée",
      "partlyPaid": "Payée en partie",
      "paid": "Payée"
    },
    "paymentStatus": {
      "pending": "Prévu",
      "completed": "Payé",
      "cancelled": "Annulé"
    },
    "pricingMode": {
      "retail": "Détail",
      "wholesale": "Gros"
    },
    "shiftStatus": {
      "open": "Ouvert",
      "pendingApproval": "En attente d’un responsable",
      "closed": "Clôturé"
    },
    "dayEvent": {
      "saleCancelled": "Vente annulée en caisse",
      "paymentVoided": "Paiement annulé",
      "refundWithoutReceipt": "Remboursement sans ticket",
      "lateReturn": "Retour hors délai",
      "largeDiscount": "Remise au-dessus de la limite",
      "cashVariance": "Écart de caisse, approuvé",
      "cashVariancePending": "Écart de caisse, en attente d’un responsable",
      "drawerOpened": "Tiroir ouvert sans vente",
      "approvalDiscount": "Accord : remise importante",
      "approvalVoid": "Accord : annulation ou correction",
      "approvalRefund": "Accord : remboursement sans ticket",
      "approvalLateReturn": "Accord : retour hors délai"
    },
    "orderEvent": {
      "placed": "Passées",
      "shipped": "Expédiées",
      "collected": "Retirées",
      "handedOver": "Remises",
      "delivered": "Livrées",
      "cancelled": "Annulées",
      "returned": "Rapportées"
    }
  },
  "summary": {
    "products_one": "{{value}} produit",
    "products_other": "{{value}} produits",
    "value": "{{value}} TND",
    "low": "{{value}} bas",
    "out": "{{value}} en rupture",
    "negative": "{{value}} négatifs",
    "overstock": "{{value}} en surstock",
    "pairs_one": "{{value}} endroit sous zéro",
    "pairs_other": "{{value}} endroits sous zéro",
    "lines_one": "{{value}} ligne de mouvement",
    "lines_other": "{{value}} lignes de mouvement",
    "inValue": "Entrées {{value}} TND",
    "outValue": "Sorties {{value}} TND",
    "adjustments_one": "{{value}} ajustement",
    "adjustments_other": "{{value}} ajustements",
    "losses": "Retiré {{value}} TND",
    "net": "Net {{value}} TND",
    "transfers_one": "{{value}} transfert",
    "transfers_other": "{{value}} transferts",
    "inTransit": "{{value}} en transit",
    "late": "{{value}} en retard",
    "lossValue": "Perdu {{value}} TND",
    "counts_one": "{{value}} inventaire",
    "counts_other": "{{value}} inventaires",
    "overLimit": "{{value}} au-dessus du seuil",
    "dead_one": "{{value}} article dormant",
    "dead_other": "{{value}} articles dormants",
    "deadValue": "Stock dormant {{value}} TND",
    "people_one": "{{value}} personne",
    "people_other": "{{value}} personnes",
    "actions_one": "{{value}} action",
    "actions_other": "{{value}} actions",
    "orders_one": "{{value}} vente",
    "orders_many": "{{value}} ventes",
    "orders_other": "{{value}} ventes",
    "sales": "Vendu {{value}} TND",
    "returns": "Retours {{value}} TND",
    "allowances": "Remboursements sans retour {{value}} TND",
    "tax": "TVA {{value}} TND",
    "discounts": "Remises accordées {{value}} TND",
    "averageTicket": "Panier moyen {{value}} TND",
    "received": "Encaissé {{value}} TND",
    "refunded": "Remboursé {{value}} TND",
    "settled": "Versé par les livreurs {{value}} TND",
    "pending": "Non versé {{value}} TND",
    "pendingOrders_one": "{{value}} livraison non versée",
    "pendingOrders_many": "{{value}} livraisons non versées",
    "pendingOrders_other": "{{value}} livraisons non versées",
    "lateOrders_one": "{{value}} en retard",
    "lateOrders_many": "{{value}} en retard",
    "lateOrders_other": "{{value}} en retard",
    "gross": "TTC {{value}} TND",
    "stampDuty": "Droit de timbre {{value}} TND",
    "salesExclTax": "Ventes HT {{value}} TND",
    "cost": "Coût {{value}} TND",
    "margin": "Marge {{value}} TND",
    "marginPercent": "Marge {{value}} %",
    "withoutCost_one": "{{value}} produit sans coût",
    "withoutCost_many": "{{value}} produits sans coût",
    "withoutCost_other": "{{value}} produits sans coût",
    "zReports_one": "{{value}} rapport Z",
    "zReports_many": "{{value}} rapports Z",
    "zReports_other": "{{value}} rapports Z",
    "variance": "Écart {{value}} TND",
    "receipts_one": "{{value}} réception",
    "receipts_other": "{{value}} réceptions",
    "amountDue": "À payer {{value}} TND",
    "paid": "Payé {{value}} TND",
    "open": "Reste à payer {{value}} TND",
    "payments_one": "{{value}} paiement",
    "payments_other": "{{value}} paiements",
    "scheduled": "Prévu {{value}} TND",
    "owed": "Dû aux fournisseurs {{value}} TND",
    "suppliersOwed_one": "{{value}} fournisseur à payer",
    "suppliersOwed_other": "{{value}} fournisseurs à payer",
    "openReceipts_one": "{{value}} réception pas entièrement payée",
    "openReceipts_other": "{{value}} réceptions pas entièrement payées",
    "wholesaleSales": "En gros {{value}} TND",
    "promotionCount_one": "{{value}} promotion",
    "promotionCount_many": "{{value}} promotions",
    "promotionCount_other": "{{value}} promotions",
    "promotions": "Promotions {{value}} TND",
    "handDiscounts": "Remises manuelles {{value}} TND"
  },
  "days_one": "{{count}} jour",
  "days_other": "{{count}} jours",
  "total": "Total",
  "showLines": "Lignes",
  "hideLines": "Masquer les lignes",
  "issued": "{{quantity}} sortis",
  "empty": "Rien à afficher pour ces filtres.",
  "truncated": "Seules les {{count}} premières lignes sont affichées et exportées. Affinez les filtres pour voir le reste.",
  "costsHidden": "Les valeurs sont masquées : il faut la permission « voir les coûts ».",
  "teaser": {
    "title": "Plus sortis · 30 derniers jours",
    "dead_one": "Stock dormant : {{count}} article · {{value}} TND",
    "dead_other": "Stock dormant : {{count}} articles · {{value}} TND",
    "open": "Ouvrir"
  },
  "dayFigures": {
    "net": "Ventes nettes",
    "orders": "Ventes",
    "units": "Quantité vendue",
    "received": "Encaissé",
    "margin": "Marge",
    "tax": "TVA",
    "toCheck": "À vérifier",
    "lastWeek": "{{weekday}} dernier : {{value}} TND",
    "lastWeekSoFar": "À la même heure {{weekday}} dernier : {{value}} TND",
    "noComparison": "Aucune vente {{weekday}} dernier",
    "averageTicket": "Panier moyen {{value}} TND",
    "discounts": "Remises accordées {{value}} TND",
    "returns": "Retours et remboursements {{value}} TND",
    "marginPercent": "{{value}} % des ventes HT",
    "netExclTax": "Ventes HT {{value}} TND",
    "nothingToCheck": "Rien à vérifier",
    "openShifts_one": "{{count}} service encore ouvert",
    "openShifts_other": "{{count}} services encore ouverts",
    "allClosed": "Tous les services sont clôturés",
    "newCustomers_one": "{{count}} nouveau client",
    "newCustomers_other": "{{count}} nouveaux clients"
  }
}
